import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "It is a nice experience using the FitClub, It really helped me in mentoring throughout my journey.",
    name: 'RITESH SINGH',
    status : 'FITNESS MODEL'
  },
  {
    image: image2,
    review: 'I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body! ',
    name: 'RAJA PRIYANSHU',
    status: 'CALISTHANICS'    
  },
  {
    image : image3,
    review:' I never thought that joining the FitClub would take me so far in this milestone.',
    name: 'ROHIT KUMAR YADAV',
    status: "CUSTOMER"
  }
];
